import React from 'react'
import { Field } from 'redux-form'
import renderSelect from '../fields/renderSelect'
import renderField from '../fields/renderField'
import i18n from '../../translations/i18n';

let ShippingInformation = props => {
	let lng = props.lng;
	return (
		<div>
			<div className="form-section">
				<div className="subtitle title title-border title-border text-left">
					<h6>{i18n.t('shipping.title', {lng})}</h6>
				</div>
				<div className="row">
					<div className="col-12 form-input">
						<Field
							name="shippingaddressline1"
							type="text"
							component={renderField}
							label={i18n.t('shipping.address_line_1', {lng})}
							onBlur={props.shippingAddressChange}
							placeholder={i18n.t('shipping.address_line_1_placeholder', {lng})}
						/>
					</div>
					<div className="col-12 form-input">
						<Field
							name="shippingaddressline2"
							type="text"
							component={renderField}
							label={i18n.t('shipping.address_line_2', {lng})}
							placeholder={i18n.t('shipping.address_line_2_placeholder', {lng})}
							onBlur={props.shippingAddressChange}
						/>
					</div>
					<div className="col-12 col-sm-6 form-input">
						<Field
							name="shippingpostalcode"
							type="text"
							component={renderField}
							label={i18n.t('shipping.postal_code', {lng})}
							onBlur={props.shippingAddressChange}
							placeholder={i18n.t('shipping.postal_code_placeholder', {lng})}
						/>
					</div>
					<div className="col-12 col-sm-6 form-input">
						<Field
							name="shippingcity"
							type="text"
							component={renderField}
							label={i18n.t('shipping.city', {lng})}
							onBlur={props.shippingAddressChange}
							placeholder={i18n.t('shipping.city_placeholder', {lng})}
						/>
					</div>
					<div className="col-12 form-input">
						<Field
							name="shippingCountry"
							component={renderSelect}
							label={i18n.t('shipping.country', {lng})}
							options={props.countries}
							onChange={props.deliveryChange}
							onBlur={props.shippingAddressChange}
							placeholder={i18n.t('app.please_select', {lng})}
						/>
					</div>
					{(props.shippingCountry==="United States") && <div className="col-12 form-input">
						<Field
							name="shippingState"
							component={renderField}
							label={i18n.t('shipping.state', {lng})}
							onBlur={props.shippingAddressChange}
						/>
					</div>}
				</div>
			</div>
	</div>
	)
}


export default ShippingInformation



// WEBPACK FOOTER //
// ./src/components/common/shippingInformation.js